import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { StatisticsPanelEntregaObrasChecklist } from "./components/statistics_panel";
import { useMemo } from "react";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import { useEntregaObrasClienteListaViewModel } from "../../viewModels/entrega_obras_cliente_lista_view_model";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { PesquisaVistoriasPanel } from "./components/pesquisa_vistoria_panel";
import { GenerateEntregaObrasVerificacaoListaColumn } from "./columns";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { EntregaObraClienteLista } from "../../../domain/models/entrega_obra_cliente_lista";
import { EntregaObraClienteArquivoModal } from "./components/entrega_obra_cliente_arquivo_modal";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { EntregaObraClienteArquivoModel } from "../../../domain/models/entrega_obra_cliente_arquivo";
import { GenerateEntregaObraArquivosListaColumns } from "./columns/generateEntregaObraClientesArquivo";
import { CadastroVistoriaModal } from "./components/cadastro_vistoria_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { EntregaObraClienteReportFotoModal } from "./components/entrega_obra_cliente_report_foto_modal";
import { EntregaObraClienteReportGeralModal } from "./components/entrega_obra_cliente_report_geral_modal";
import { EntregaObraChecklistServicoGraficoModal } from "./components/entrega_obra_checklist_servico_grafico_modal";
import CascateList from "../../../../../common/components/cascate_list";

/**
 * EntregaObrasClienteLista
 */

export const EntregaObrasClienteLista = () => {
  const viewModel = useEntregaObrasClienteListaViewModel();

  const columnsDef = useMemo(() => {
    return GenerateEntregaObrasVerificacaoListaColumn({
      onActionDeletar: viewModel.handleDeleteVistoriaOpenState,
      onActionReportSimple: viewModel.handleReportSimple,
      onActionReportFoto1: viewModel.handleReportFotoOpenState,
      onActionReportFoto2: viewModel.handleReportFotoOpenState,
      onEnterItemVerificacao: viewModel.handleItemVerificacaoPage,
    });
  }, [
    viewModel.handleDeleteVistoriaOpenState,
    viewModel.handleReportSimple,
    viewModel.handleReportFotoOpenState,
    viewModel.handleItemVerificacaoPage,
  ]);

  const clienteArquivosColumnsDef = useMemo(() => {
    return GenerateEntregaObraArquivosListaColumns({
      onActionEdit: viewModel.handleArquivoModalOpenState,
      onActionDelete: viewModel.handleDeleteArquivoOpenState,
      onActionDownload: viewModel.handleDownloadArquivo,
    });
  }, [viewModel.handleArquivoModalOpenState,
  viewModel.handleDeleteArquivoOpenState,
  viewModel.handleDownloadArquivo]);

  const tabelaArquivo = useMemo(() => {
    return (
      <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
        <StyledDataGrid
          tableName="centro_custo_cadastro_2"
          disableColumnMenu={false}
          getRowId={(row: EntregaObraClienteArquivoModel) => row.idEntregaObraClienteArquivo}
          columns={clienteArquivosColumnsDef}
          loading={viewModel.loading}
          height='35vh'
          rows={viewModel.arquivosLista ?? []}
          rowCount={viewModel.arquivosLista?.length ?? 0}
          pageSizeOptions={[5]}
          paginationMode="server"
          paginationModel={{
            page: 1,
            pageSize: 100,
          }}
          pinnedColumns={{
            right: ['idEntregaObraClienteArquivo'],
          }}
          getRowHeight={() => 'auto'}
          autoHeight={true}
        />

      </div>
    );
  }, [
    viewModel,
    clienteArquivosColumnsDef,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="flex items-center ml-6">
              <div className="flex items-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden h-[34px]">
                <div className="bg-gray-100 text-black text-[10px] font-bold uppercase tracking-wider px-3 h-full flex items-center border-r border-gray-200">
                  Centro de Custo
                </div>
                <div className="px-4 text-sm font-bold text-primary-green h-full flex items-center">
                  {viewModel.entregaObraParametros?.nomeCentroCusto || '-'}
                </div>
              </div>
            </div>
          }

          rightSlot={
            <div className="flex flex-row w-full justify-end gap-2">
              <BackButton onClick={() => viewModel.handlePageBack()} />

              <div>
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => {
                    viewModel.handleReportGeralOpenState(true);
                    e.preventDefault();
                  }}>
                  Relatório Geral
                </PrimaryButton>
              </div>

              <div className="w-[10rem]">
                <PrimaryButton
                  buttonColor="secondary"
                  onMouseDown={e => {
                    viewModel.handleGraficoOpenState(true);
                    e.preventDefault();
                  }}>
                  Gráfico Resumo
                </PrimaryButton>
              </div>

            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-4 px-4 mb-4">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Entrega Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to='/EntregaObras_lista'>Assistência e Entrega de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Entrega por Cliente
          </Typography>
        </Breadcrumbs>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                {
                  viewModel.entregaObraParametros &&
                  <StatisticsPanelEntregaObrasChecklist
                    entregaObraParametros={viewModel.entregaObraParametros}
                  />
                }
                <>
                  <CascateList title="Arquivos Diversos" defaultOpen={false}>
                    <div className="w-full flex flex-col ">
                      <div className="w-full flex flex-row justify-end items-end mb-2">
                        {/* <h1 className="font-bold text-black dark:text-white text-3xl">Arquivos Diversos</h1> */}
                        <div>
                          <PrimaryButton
                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                            sx={{ px: 2 }}
                            onClick={() => viewModel.handleArquivoModalOpenState(null, true)}>
                            Novo Arquivo
                          </PrimaryButton>
                        </div>
                      </div>
                      {tabelaArquivo}
                    </div>
                  </CascateList>
                </>

                <PesquisaVistoriasPanel
                  ddlChecklistEntregaObra={viewModel.ddlChecklistEntregaObra ?? []}
                  ddlCliente={viewModel.ddlCliente}
                  selectedIdsChecklist={viewModel.filters.idsChecklist}
                  selectedIdsCliente={viewModel.filters.idsClientes}
                  unidade={viewModel.filters.unidade}
                  localVistoria={viewModel.filters.localVistoria}
                  entregue={viewModel.filters.entregue}
                  tipoVistoria={viewModel.filters.tipoVistoria}
                  dataDe={viewModel.filters.dataDe}
                  dataAte={viewModel.filters.dataAte}

                  onClearFilters={viewModel.handleClearFilters}
                  handleIdChecklistChange={viewModel.handleIdsChecklistChange}
                  handleIdClienteChange={viewModel.handleIdsClienteChange}
                  handleLocalVistoriaChange={viewModel.handleLocalVistoriaChange}
                  handleEntregueChange={viewModel.handleEntregueChange}
                  handleUnidadeChange={viewModel.handleUnidadeChange}
                  handleDataRangeChange={viewModel.handleDataRangeChange}
                  handleTipoVistoriaChange={viewModel.handleTipoVistoriaChange}
                />

                <Stack spacing={0}>
                  <StyledDataGrid
                    tableName="Clientes_Lista"
                    disableColumnMenu={false}
                    showToolbar={true}
                    disableRowSelectionOnClick={true}
                    getRowId={(row: EntregaObraClienteLista) => row.idEntregaObraCliente}
                    columns={columnsDef}
                    loading={viewModel.loading}
                    checkboxSelection={false}
                    rows={viewModel.vistoriasLista ?? []}
                    rowCount={viewModel.vistoriasLista?.length ?? 0}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    pinnedColumns={{
                      right: ['idEntregaObraCliente'],
                    }}
                    getRowHeight={() => 'auto'}
                    autoHeight={true}
                    textSize="muitoPequeno"
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * BottomBar
        */}

      <BottomBar>
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
          </div>

          <div className="flex flex-row gap-4">
            {

              <div className="w-[200px]">
                <PrimaryButton
                  buttonColor="primary-green"
                  onClick={() => viewModel.handleVistoriaOpenState(true)}
                  startIcon={<DynamicIcon nameIcon="Check" size={25} className="text-[#009C4E]" />}>
                  Nova Vistoria
                </PrimaryButton>
              </div>
            }
          </div>
        </div>
      </BottomBar>

      {/**
        * Modals
        */}

      <EntregaObraClienteArquivoModal
        open={viewModel.openCadastroArquivosModal}
        saving={viewModel.saving}
        idEntregaObra={viewModel.selectedIdEntregaObra ?? 0}
        selectedEntregaObraArquivo={viewModel.selectedArquivo ?? null}
        onClose={() => viewModel.handleArquivoModalOpenState(null, false)}
        onSubmit={viewModel.handleSubmitNewArquivo}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
        onDownload={viewModel.handleDownloadArquivo}

      />

      <CadastroVistoriaModal
        open={viewModel.openCadastroVistoriasModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        nomeCentroCusto={viewModel.entregaObraParametros?.nomeCentroCusto ?? ''}
        idCentroCusto={viewModel.entregaObraParametros?.idCentroCusto ?? 0}
        ddlChecklistEntregaObra={viewModel.filteredChecklistEntregaObraDropdown ?? []}
        onClose={() => viewModel.handleVistoriaOpenState(false)}
        onSubmit={viewModel.handleSubmitNewVistoria}
      />

      {/* Arquivo */}
      <DeleteDialog
        open={viewModel.openDeleteArquivosModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteArquivoOpenState(null, false)}
        title={`Você realmente deseja excluir este arquivo?`}
        onDelete={viewModel.handleSubmitDeleteArquivo}
      />

      {/* Vistoria */}
      <DeleteDialog
        open={viewModel.openDeleteVistoriasModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteVistoriaOpenState(null, false)}
        title={`Você realmente deseja excluir esta vistoria?`}
        onDelete={viewModel.handleSubmitDeleteVistoria}

      />


      <EntregaObraChecklistServicoGraficoModal
        open={viewModel.openGraficoModal}
        loading={viewModel.loading}
        entregaObraGrafico={viewModel.estatisticasChecklist}
        onClose={() => viewModel.handleGraficoOpenState(false)}
      />

      <EntregaObraClienteReportGeralModal
        open={viewModel.openReportGeralModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedIdEntregaObra={viewModel.selectedIdEntregaObra ?? 0}
        onClose={() => viewModel.handleReportGeralOpenState(false)}
        onSubmit={viewModel.handleReportGeral}

        ddlChecklist={viewModel.ddlChecklistReport ?? []}
        ddlCliente={viewModel.ddlClienteReport ?? []}
        ddlUnidade={viewModel.ddlUnidadeReport ?? []}
        ddlLocalVistoria={viewModel.ddlLocalVistoriaReport ?? []}
      />

      <EntregaObraClienteReportFotoModal
        open={viewModel.openReportFotoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.handleReportFotoOpenState(null, false, 0)}
        onSubmit={viewModel.handleReportFotografico}
      />
      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>

  );
}


